export const REDIRECT_URL = 'https://app.adjust.com/'
export const ANDROID_PATH = '9omaumd'
export const IOS_PATH = '7c7enqa'
